import React from "react";
import { useTemplateRoutes } from "hooks";
import { NavigationPageItems } from "components";

export const TemplatesNavigationPage: React.FC = () => {
  const { TemplateNavigationRoot } = useTemplateRoutes();
  return <NavigationPageItems navigationRoot={TemplateNavigationRoot} />;
};
